<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="main-container">
  <div class="flex justify-evenly items-center pt-[150px]">
    <div class="otp-verification w-[711px]">
      <div class="title flex flex-col justify-evenly items-center">
        <h3 class="text-[#232B31] mb-4 font-bold">
          Enter OTP code for verification!
        </h3>
        <div class="flex flex-col mb-8 text-sm justify-evenly items-center">
          <span class="text-[#787D81]">We have sent a 6-numbers OTP code</span>
          <span class="text-[#787D81]">
            to
            @if (email) {
              <strong>
                {{ email }}
              </strong>
            } @else {
              <strong>
                {{ phoneNumber }}
              </strong>
            }
          </span>
        </div>
      </div>
      <div class="otp flex flex-col mx-2 justify-evenly items-center">
        <div class="flex justify-center items-center">
          @for (number of otpnumber; track $index) {
            <div class="otp-wrapper m-1 p-0.5 rounded-md max-w-sm">
              <form [formGroup]="otpTyped">
                <input
                  #inputEl
                  type="text"
                  (keydown)="handleKeyDown($event, $index)"
                  (focus)="handleFocus($event,$index)"
                  (focusout)="handleFocusOut($event)"
                  (blur)="onTouched?.()"
                  (keypress)="handleKeyPress($event, $index)"
                  (input)="handleInput($index)"
                  [formControlName]="otpFormConstant.otp.key + $index"
                  class="p-3 m-[0.5px] rounded-md w-[36px] h-[52px]  focus:border-2 focus:border-green-600 active:border-0 active:border-green-600 " />
              </form>
            </div>
          }
        </div>
        <span class="my-4"
          >The Code will be active in:

          <strong>{{ display }}</strong>
        </span>
      </div>
    </div>
  </div>
  <div class="bottm-content grid mt-8 place-items-center">
    <button
      #submit
      type="submit"
      class="first-btn disabled:cursor-none h-[57px] w-[25%] flex justify-center text-white items-center break-inside bg-primary rounded-xl px-8 py-2 mb-4 mt-4 w-medium drop-shadow-lg disabled:bg-transparent disabled:text-gray-300 disabled:outline-gray-200"
      (click)="handleSubmit()"
      [disabled]="!otpTyped.valid">
      Submit
    </button>
    <span class="flex justify-center items-center"></span>
    Didn't get the OTP code? <br />
    <span
      class="cursor-pointer underline-offset-1 hover:text-green-300"
      *ngIf="completedTimer"
      (click)="resendOtp()"
      >Tap Here</span
    >
  </div>
</div>
